var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHourGlass(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_567_45929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.061 48.1073C88.0834 40.7931 98.9323 30.9011 99.9211 7.26904H107.084V0.179199H14.916V7.26904H22.0789C23.0677 30.9011 33.9166 40.7931 41.939 48.1073C47.3204 53.0137 50.3652 56.0167 50.3652 60.6792C50.3652 65.3417 47.3204 68.3447 41.939 73.2511C33.9166 80.5653 23.0677 90.4573 22.0789 114.089H14.916V121.179H107.084V114.089H99.9211C98.9323 90.4573 88.0834 80.5653 80.061 73.2511C74.6796 68.3447 71.6348 65.3417 71.6348 60.6792C71.6348 56.0167 74.6796 53.0137 80.061 48.1073ZM57.4551 87.2515C56.3602 87.4774 55.2785 87.8061 54.2228 88.2429L32.5097 97.2278C36.0556 88.2119 41.7667 83.0025 46.7156 78.4905C52.2386 73.4551 57.4551 68.699 57.4551 60.6792V87.2515ZM75.2844 78.4905C80.2333 83.0025 85.9442 88.2119 89.4903 97.2276L67.7772 88.2426C66.7215 87.8059 65.6398 87.4772 64.5449 87.2512V60.6792C64.5449 68.699 69.7614 73.4551 75.2844 78.4905ZM32.3852 23.812C30.6711 19.3456 29.4873 13.9529 29.1775 7.26904H92.8223C92.5125 13.9529 91.3289 19.3456 89.6146 23.812H32.3852Z",
    fill: "#0176D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_567_45929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 121,
    height: 121,
    fill: "white",
    transform: "translate(0.5 0.179199)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourGlass);
export default __webpack_public_path__ + "static/media/hourGlass.f91406e6abfde6a954c189dd341b5250.svg";
export { ForwardRef as ReactComponent };